import { MdClose, MdContentCopy, MdFormatColorFill, MdOutlineContentPaste } from 'react-icons/md'

import type { ReactElement } from 'react'

import LokaliseLogo from '~/assets/lokalise-logo.svg'
import Button from '~/components/Buttons/Button'
import { copyText } from '~/utils/navigator'

import './styles.scss'

interface Props {
  copyValue?: string
  onColorEdit?: VoidFunction
  onDelete?: VoidFunction
  onPaste?: VoidFunction
  translationKey?: string
  translationProject?: string
}

const InputControls = ({
  copyValue,
  onColorEdit,
  onDelete,
  onPaste,
  translationKey,
  translationProject,
}: Props): ReactElement => {
  const handleCopy = () => copyText(copyValue, 'Copied to clipboard.')

  const handleLokaliseIconClick = () =>
    window.open(`https://app.lokalise.com/project/${translationProject}/?view=multi&search=${translationKey}`, '_blank')

  return (
    <div className="translation-controls" onClick={(evt) => evt.stopPropagation()}>
      {onColorEdit ? (
        <Button ghost onClick={onColorEdit}>
          <MdFormatColorFill />
        </Button>
      ) : null}
      {copyValue ? (
        <Button ghost onClick={handleCopy}>
          <MdContentCopy size={15} />
        </Button>
      ) : null}
      {translationKey && translationProject ? (
        <Button ghost onClick={handleLokaliseIconClick}>
          <img className="lokalise-icon" src={LokaliseLogo} />
        </Button>
      ) : null}
      {onDelete ? (
        <Button ghost onClick={onDelete}>
          <MdClose color="#626262" size={15} />
        </Button>
      ) : null}
      {onPaste ? (
        <Button ghost onClick={onPaste}>
          <MdOutlineContentPaste size={15} />
        </Button>
      ) : null}
    </div>
  )
}

export default InputControls
